export enum EPublishOfferStatus {
  initial = 'initial',
  pending = 'pending',
  success = 'success',
  fail = 'fail',
}

export enum EPublishOfferErrorCode {
  /** неверный запрос */
  badRequest = 'badRequest',
  /** неизвестная ошибка на сервере */
  fatalError = 'fatalError',
  /** ошибка валидации */
  validationError = 'validationError',
}
